import { Spacing, Text, Title } from '@vkontakte/vkui';
import img from 'img/tooltip/paid-features-sharing-tooltip.png';
import React, { type RefObject, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';

import styles from './PaidFeaturesTooltip.css';

interface PaidFeaturesTooltipProps {
    forcePromo: boolean;
    target: RefObject<HTMLElement> | Element | null;
    onClose: () => void;
    onShow: () => void;
}

export const PAID_FEATURES_TOOLTIP_ID = 'paidFeaturesTooltipId';

export function PaidFeaturesTooltip({ target, forcePromo, onClose, onShow }: PaidFeaturesTooltipProps) {
    const dispatch = useDispatch();
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (forcePromo) {
            setTimeout(() => setShowTooltip(forcePromo), 400); // таймаут чтоб не конфликтовало с анимацией появления окна шеринга
            dispatch(UserStorageActions.set(PAID_FEATURES_TOOLTIP_ID, new Date().valueOf()));
        }
    }, [dispatch]);

    const onTooltipShow = useCallback(() => {
        // аналитика
        onShow();
    }, [onShow]);

    const onTooltipClose = useCallback(() => {
        // аналитика
        onClose();
    }, [onClose]);

    return showTooltip ? (
        <FloatingTooltip
            contentClassName={styles.root}
            target={target}
            placement={ETooltipPlacement.right}
            qaId="paid-features-sharing-tooltip"
            withinModal
            closable
            closeOnOutsideClick
            usePortal
            onShow={onTooltipShow}
            onClose={onTooltipClose}
        >
            <div className={styles.tooltip}>
                <Title className={styles.tooltipTitle}>Пользуйтесь!</Title>
                <Spacing size={4} />
                <Text className={styles.tooltipText}>У&nbsp;вас подписка Mail Space&nbsp;&mdash; попробуйте новые настройки</Text>
                <img src={img} alt="Пользуйтесь!" className={styles.image} />
            </div>
        </FloatingTooltip>
    ) : null;
}
